import React from 'react'
import { InputTextarea } from "primereact/inputtextarea";

const InputFeildTextArea = ({ value, onChange, label, errorMessage }) => {
  return (
    <div className="flex-auto mb-1">
                <label htmlFor="stacked-buttons" className="font-bold block mb-2">{label}</label>
                <div className="flex flex-column gap-2 ">
                    <InputTextarea value={value} invalid={errorMessage} onChange={onChange} placeholder={label} rows={5} cols={30}/>
                    {errorMessage && 
                        <small id="username-help">
                          {errorMessage}
                        </small>}
                </div>    
    </div>
    
  )
}

export default InputFeildTextArea
